<template>
    <!-- select category -->
    <div class="row" style="z-index: 10">
        <p>Selecciona la categoría para el producto:</p>
        <div class="col-12 overflow-hidden" style="height: 340px">
            <treeselect v-model="value"
                :alwaysOpen="true"
                :multiple="false"
                :options="optionsTree"
                showCount="true"
                defaultExpandLevel="3"
                maxHeight="300"
                placeholder="Selecciona la categoría"
                openDirection="below"
                zIndex="888"
                :required="true"
                showCountOf="ALL_CHILDREN"
                :allowClearingDisabled="true"/>
        </div>
        <input type="hidden" name="category_id" :value="value">
    </div>
    <!-- END select category -->

    <!-- btn add category -->
    <div class="row">
        <div class="col-12">
            <a href="#" class="link-primary float-end me-3 mt-1" data-bs-toggle="modal" data-bs-target="#modal-products-category" @click="form.reset()">+ Añadir categoria</a>
        </div>
    </div>
    <!-- END btn add category -->

    <!-- Modal -->
    <div class="modal fade" id="modal-products-category" data-bs-backdrop="static" tabindex="-1" aria-labelledby="modal-products-category" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        Añadir nueva categoría
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel"></button>
                </div>
                <form @submit.prevent="addCategory" @keydown="form.onKeydown($event)">
                    <div class="text-start modal-body">
                        <AlertError :form="form" />
                        <AlertSuccess :form="form" :message="message" />

                        <div class="mb-3">
                            <label class="form-label">Nombre (ES)</label>
                            <input type="text" class="form-control" v-model="form.name_es" name="name_es">
                            <HasError :form="form" field="name_es" />
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Nombre (EN)</label>
                            <input type="text" class="form-control" v-model="form.name_en" name="name_en">
                            <HasError :form="form" field="name_en" />
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Nombre (FR)</label>
                            <input type="text" class="form-control" v-model="form.name_fr" name="name_fr">
                            <HasError :form="form" field="name_fr" />
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Categoría padre</label>
                            <select class="form-select" v-model="form.category_id">
                                <option selected value="null">Ninguna</option>
                                <option v-for="(option, index) in optionsList" :value="index" :key="index" >{{ option }}</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <div class="form-check form-switch">
                                <input v-model="form.active" class="form-check-input" type="checkbox" role="switch" name="active" id="product-status">
                                <label class="form-check-label" for="product-status">Activo</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="link-danger float-end me-3 mt-1" data-bs-dismiss="modal" @click="cancel">Cancelar</a>
                        <Button class="btn btn-primary btn-sm float-end" :form="form">
                            <i class="fa fa-plus"></i> Crear
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- End Modal -->
</template>

<script>
    import Form from 'vform'
    import Treeselect from 'vue3-treeselect'

    export default {
        components: { Treeselect },

        props: {
            selected: {
                type: Number,
                default: null
            },
            categoriesTree: {
                type: Array,
                required: true
            },
            categoriesList: {
                type: Array,
                required: true
            }
        },

        data: function () {
            return {
                form: new Form({
                    name_es: '',
                    name_en: '',
                    name_fr: '',
                    category_id: null,
                    active: true,
                }),
                value: null,
                optionsTree: [],
                optionsList: [],
                message: ''
            }
        },

        created () {
            this.value = this.selected
            this.optionsTree = this.categoriesTree
            this.optionsList = this.categoriesList
        },

        methods: {
            async addCategory () {

                const response = await this.form.post('/admin/categories-add')
                    .then((response) => {
                        if (response.status == 200) {
                            console.log(response.data.selected)
                            this.optionsTree = response.data.categories.tree
                            this.optionsList = response.data.categories.list
                            this.value = response.data.selected
                            this.message = response.data.message
                            //this.form.reset()
                        }
                    })
            },
            clear () {
                this.form.reset()
                this.message = ''
            }
        }
    }
</script>
